import { useState } from "react";
import { api } from "../../api/client";
import type { AthleteDetail } from "../../api/types";
import { useAuth } from "../../auth/AuthContext";
import { ActivityList } from "../../components/ActivityList";
import { ImportPanel } from "../../components/ImportPanel";
import { ErrorState, PageHead } from "../../components/ui";
import { useAsync } from "../../lib/useAsync";
import { Link } from "../../router/router";
import { t } from "../../i18n";

export function AthleteActivitiesPage({ orgId, athleteId }: { orgId: string; athleteId: string }) {
  const { can } = useAuth();
  const [reload, setReload] = useState(0);
  const athlete = useAsync(() => api.get<AthleteDetail>(`/orgs/${orgId}/athletes/${athleteId}`), [orgId, athleteId]);
  const base = `/org/${orgId}/atletas/${athleteId}`;
  if (athlete.error) return <ErrorState error={athlete.error} />;
  return (
    <>
      <p style={{ marginBottom: 8 }}>
        <Link to={`/org/${orgId}/atletas`}>{t("Atletas")}</Link>
        {athlete.data && (
          <>
            {" / "}
            <Link to={base}>{athlete.data.full_name}</Link>
          </>
        )}
      </p>
      <PageHead
        title={athlete.data ? t("Atividades: {full_name}", { full_name: athlete.data.full_name }) : t("Atividades")}
        actions={
          can("plans.manage") && (
            <Link to={`${base}/planilha`} className="btn btn-secondary">
              {t("Abrir planilha")}
            </Link>
          )
        }
      />
      {can("activities.manage") && (
        <ImportPanel
          orgId={orgId}
          uploadPath={`/orgs/${orgId}/athletes/${athleteId}/imports`}
          activityHref={(id) => `${base}/atividades/${id}`}
          title={t("Importar para este atleta")}
          onImported={() => setReload((n) => n + 1)}
        />
      )}
      <ActivityList listPath={`/orgs/${orgId}/athletes/${athleteId}/activities`} hrefFor={(a) => `${base}/atividades/${a.id}`} reloadKey={reload} />
    </>
  );
}
